import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import { Framework } from '@flint/framework';

import { authProvider } from "../../../common/authProvider";

const drawerWidth = 280;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end',
    ...theme.mixins.toolbar,
  },
  navBarText: {
    "fontFamily": "Nunito Sans",
    "fontWeight": "bold",
    "fontSize": "26px",
    "color": "#FFFFFF",
    "cursor": "pointer",
  },
  menuItem: {
    fontFamily: "Nunito Sans",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "16px",
    lineHeight: "163.42%",
    color: "#222747",
    "&:hover": {
      color: "#DD7153",
    }
  },
  vetLink: {
    textDecoration:"none",
    color: "#222747",
    "&:hover": {
      color: "#DD7153",
    }
  },
  userBox: {
    display: "flex",
    padding: theme.spacing(2.5, 1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(221,113,83,0.1)",
    }
  },
  userAvatar: {
    margin: theme.spacing(0, 1),
    display: "flex",
    alignItems: "center",
  },
  userDetails: {
    fontFamily: "Nunito Sans",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "16px",
    lineHeight: "163.42%",
    color: "#979EB6",
  },
}));

const NavBar = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const drawerItems = [
    {text: "Show all ePubs", url: "/epubs"},
    {text: "Upload ePub", url: "/add-epub"},
    {text: "Upload CSV", url: "/upload-csv"},
    {text: "Add Genus Specialty", url: "/add-genus-specialty"},
    {text: "Show all Products", url: "/subscriptions"},
    {text: "Create a new Product", url: "/add-subscription"},
    {text: "Show all users", url: "/users"}
  ];

  const handleDrawerOpen = () => {
    setOpen(true);
    props.checkDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
    props.checkDrawerOpen(false);
  };

  const navigationHandler = (url) => {
    Framework.redirect(url);
    setOpen(false);
    props.checkDrawerOpen(false);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap className={classes.navBarText} onClick={() => Framework.redirect(`/`)}>
            VetConsult Admin Panel
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        <div className={classes.userBox}>
          <div className={classes.userDetails}>
            <p>{authProvider.account.name}</p>
            <p>{authProvider.account.userName}</p>
          </div>
        </div>
        <Divider />
        <List>
          <ListItem button key="go to vet" className={classes.menuItem}>
            <a href={process.env.REACT_APP_FRONTEND_URL} target="_blank" rel="noopener noreferrer" className={classes.vetLink}>
              <ListItemText primary="Go To VetConsult" />
            </a>
          </ListItem>
          {drawerItems.map((item) => (
            <ListItem button key={item.text} className={classes.menuItem} onClick={() => navigationHandler(item.url)}>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          <ListItem button key="logout" onClick={()=>authProvider.logout()} className={classes.menuItem}>
            <ListItemIcon><ExitToAppIcon /></ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
}

export default NavBar;